import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function OpeningHook() {
  return <section className="px-6 py-8 max-w-3xl mx-auto" data-id="element-146">
      <FadeIn data-id="element-147">
        <div className="space-y-5 text-lg md:text-xl leading-relaxed text-[#2D2A26]" data-id="element-148">
          <h2 className="text-2xl md:text-3xl text-[#4A5D3A] font-semibold mb-8" data-id="element-149">
            Cuando por fin todo se apaga afuera…
          </h2>
          <h2 className="text-2xl md:text-3xl text-[#4A5D3A] font-semibold mb-8" data-id="element-150">
            Tu mente trabaja más fuerte.
          </h2>
          <img src="https://cdn.magicpatterns.com/uploads/3vL1eci6CW3XYWGky5GZSu/imagen_2_para_la_pagina_de_venta.png" alt="Mujer despierta en la cama sin poder dormir" className="w-full max-w-xl mx-auto rounded-2xl shadow-lg my-6" data-id="element-151" />

          <p data-id="element-152">
            Tu cuerpo quiere descansar. Pero tu cabeza sigue repasando
            pendientes, conversaciones, culpa, presión y miedo.
          </p>

          <p data-id="element-153">
            No es falta de voluntad. No es que estés exagerando. Y no es que
            “así eres tú”.
          </p>

          <p className="font-bold text-2xl text-[#9B4F2B] my-6 border-l-4 border-[#9B4F2B] pl-6 py-2" data-id="element-154">
            Tu sistema nervioso sigue atrapado en modo alerta.
          </p>
        </div>
      </FadeIn>
    </section>;
}